import {
    Box,
    Button,
    Alert,
    Card,
    Container,
    Grid,
    InputAdornment,
    Typography,
    CardContent
  } from '@mui/material';
  import { Helmet } from 'react-helmet';
  import { Search as SearchIcon, Download as ExportIcon } from 'react-feather';
  import TextField from '@mui/material/TextField';
  import CustomButton from 'src/components/common/customButton';
  import FormControl from '@mui/material/FormControl';
  import BasicMenu from 'src/components/common/BasicMenu';
  import OutlinedInput from '@mui/material/OutlinedInput';
  import {Download} from 'react-feather';
  import { _axios } from 'src/plugins/axios';
  import commonService from 'src/service/common';
  import React, { useEffect, useState } from 'react';
  
  const url = "https://www.medibuddy.in/cye"
  
  function AhcCYE() {
    
    return (
      <>
        <Helmet>
          <title>AHC | Check Employee Eligibilty</title>
        </Helmet>
        {url && <Grid sx={{pl:1, mt: 2,pr:1, height: '100%'}}>
            <iframe style={{borderRadius: '10px'}} width="100%" height="100%" src={url}></iframe>
        </Grid>}

        </>
    );
  }
  
  export default AhcCYE;
  